module.exports = __webpack_public_path__ + "static/media/cssda-wotd_my_portfolio_08_12_2021.22876e2e.pdf";